export default __webpack_public_path__ + "static/media/DocSure.0f06ed5463aa9b3f4615872a030482fa.webp";